import styled from 'styled-components';


export const SpaceWrapper = styled.div`
  margin-bottom: ${props => props.bottom}px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SectionHeading = styled.h3`
  margin: 0 0 12px;
  font-size: 16px;
  line-height: 1.25;
`;

export const OptionHeading = styled.h4`
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 1.35;
`;

export const SliderWrapper = styled.div`
  margin: 30px 25px 50px 25px;

  .ant-slider {
    margin-bottom: 22px;
  }
`;
